import { setSpecificMessage, isoDateTime } from "valibot";
setSpecificMessage(
  isoDateTime,
  (issue) => `Date et heure invalide: reçu ${issue.received}`,
  "fr"
);